import {
  Criteria,
  CriteriaRequest,
  Filter,
  Order,
  OrderType,
  PaginationHelper,
} from '@daas-consulting/core-cross-interfaces';

export interface MapCriteriaToCriteriaRequestOptions {
  criterias: Criteria[];
  orderField: string;
  orderType: OrderType;
  pageIndex: number | undefined;
  pageSize: number | undefined;
}

export function mapCriteriaToCriteriaRequest({
  criterias,
  orderField,
  orderType,
  pageIndex,
  pageSize,
}: Partial<MapCriteriaToCriteriaRequestOptions>): CriteriaRequest {
  const filters: Filter[] = [];
  if (Array.isArray(criterias)) {
    criterias.forEach((criteria: Criteria) => {
      if (
        Array.isArray(criteria.attributes) &&
        criteria.attributes.length > 0
      ) {
        criteria.attributes.forEach((attr) => {
          const filter: Filter = {
            key: attr.key,
            value: attr.rawValue,
          };

          filters.push(filter);
        });
      } else {
        const filter: Filter = {
          key: criteria.key,
          value: criteria.rawValue,
        };

        filters.push(filter);
      }
    });
  }

  let orderBy: Order[] | undefined;
  if (typeof orderField === 'string' && orderField.length > 0) {
    orderBy = orderField
      .split(',')
      .map((x) => ({ field: x, type: orderType ?? 'asc' }));
  }

  const { pageIndex: safePageIndex, pageSize: safePageSize } =
    PaginationHelper.sanitize({ pageIndex, pageSize });
  const rv: CriteriaRequest = {
    filters,
    pageIndex: safePageIndex,
    pageSize: safePageSize,
    orderBy: orderBy ?? [],
  };

  return rv;
}
